var e = {
	header: {
		actions: "Room actions",
		rename: "Rename",
		markOutOfOrder: "Mark out of order",
		markActive: "Mark active",
		blockDates: "Block dates",
		delete: "Delete room"
	},
	whoIsStaying: {
		title: "Who's staying",
		inHouse: "In house now",
		arrivingToday: "Arriving today",
		departingToday: "Leaving today",
		nextArrivals: "Next arrivals",
		emptyTonight: "No one is staying tonight",
		emptyUpcoming: "No upcoming arrivals",
		nights_one: "{{count}} night",
		nights_other: "{{count}} nights",
		noBookingsAccess: "You need the bookings permission to see who is staying."
	},
	history: {
		title: "Stay history",
		empty: "No past stays",
		stay: "Stay"
	},
	housekeeping: {
		title: "Housekeeping",
		status: "Status",
		changedAt: "Changed {{when}}",
		changedBySystem: "Changed automatically",
		note: "Note",
		assignee: "Assigned to",
		unassigned: "Not assigned",
		neverChanged: "No changes recorded yet.",
		eventsTitle: "Recent changes",
		eventMoved: "{{from}} → {{to}}",
		eventFirst: "Marked {{to}}",
		assignedSomeone: "A team member",
		actions: {
			menu: "Housekeeping actions",
			change: "Change",
			markDirty: "Mark dirty",
			markClean: "Mark clean",
			markInspected: "Mark inspected",
			assign: "Assign",
			unassign: "Unassign",
			addNote: "Add note",
			editNote: "Edit note",
			manage: "Update"
		}
	},
	kpis: {
		title: "This room's figures",
		range30: "30 days",
		range90: "90 days",
		empty: "No stays in this period"
	},
	notFound: {
		title: "Room not found",
		body: "It may have been deleted, or you no longer have access to its property."
	},
	loadError: "We couldn't load this room.",
	retry: "Try again"
};
//#endregion
export { e as default };
